import * as React from 'react';
import { TileLayer } from 'react-leaflet';
let config = require('../../../cc-config.json');
/**
 * Base raster layer for the map.
 * @param theme map theme
 */
export function CityBaseMapLayer({ theme }) {
    /**
     * Ordnance Survey maps - UK / London specific
     * (replace with appropriate base map for other cities/countries)
     */
    // In either theme case, we will use OS's light theme, but add our own filter
    const theme_class = theme === 'light' ? "light-theme" : "night-theme";
    const baseUrl = config.basemapTileUrl;
    const attribution = config.baseAttribution;
    return React.createElement(TileLayer, { url: baseUrl, attribution: attribution, maxNativeZoom: 18, maxZoom: 19, detectRetina: false, className: theme_class });
}
